<template>
  <div class="header-page-card-all">
    <div class="page-header-card page-header card-base card-shadow--small button-group-card">
      <el-row :gutter="10">
        <el-col :xs="24"
                :sm="12"
                :md="12"
                :lg="16"
                :xl="16">
          <h1>{{firstTitle(param.title)}}</h1>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :key="index"
                                v-for="(item,index) in param.links">{{secondTitle(item.title)}}</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
        <el-col :xs="24"
                :sm="12"
                :md="12"
                :lg="8"
                :xl="8">
          <bAccountNumberSelect ref="bSelect"
                                @change="getAccountNumberChange"
                                class="mt-20 mb-20"></bAccountNumberSelect>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  props: ['param', 'buttons', 'buttonAction'],
  data () {
    return {}
  },
  methods: {
    onCommandLang (command) {
      this.$emit('on-click', command)
    },
    getAccountNumberChange (val) {
      this.$emit('on-click-number', val.tradeAccountNumber)
      this.$emit('getradeAccount', val)
    },
    firstTitle (key) {
      let items = this.$t('headerCard')
      return items[key] ? items[key] : key
    },
    secondTitle (key) {
      let items = this.$t('headerCard.breadcrumb')
      return items[key] ? items[key] : key
    }
  },
  components: {},
  watch: {}
}
</script>
<style lang="scss">
.header-page-card-all {
  .page-header {
    margin-top: 22px;
    // height: 100px;
    margin-bottom: 20px;
    padding-bottom: 12px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .page-header-card {
    h1 {
      font-size: 22px;
      color: #24282d;
      font-weight: bold;
      font-family: 'Muli-SemiBold';
      text-shadow: none !important;
    }

    text-shadow: none;

    // margin-left: 20px;
    // margin-right: 20px;
    .button-group-card {
      position: relative;
    }

    .el-breadcrumb__inner {
      font-size: 12px;
      font-weight: 400;
      font-family: 'Muli-Regular';
      color: #fec000 !important;
    }

    .el-breadcrumb__item:last-child {
      font-weight: bold !important;
    }

    .el-breadcrumb__separator {
      font-size: 12px;
      font-family: 'Muli-Regular';
      font-weight: bold;
      color: #fec000 !important;
    }

    .button-group {
      position: absolute;
      top: 80px;
      right: 70px;

      .el-button--primary {
        color: #fec000;
        background-color: #fff;
      }

      .el-button--info {
        color: #fec000;
        background-color: #fff;
      }

      .el-button--danger {
        color: #fec000;
        background-color: #fff;
      }
    }

    .button-group-phone {
      display: none;
    }

    @media (max-width: 822px) {
      .button-group {
        display: none;
      }

      .button-group-phone {
        display: inherit;
        position: absolute;
        top: 65px;
        right: 70px;
      }
    }

    @media (max-width: 768px) {
      .button-group-phone {
        display: inherit;
        position: absolute;
        top: 80px;
        right: 80px;
      }
    }
  }
}
</style>
